(window as any).global = window;
import 'zone.js';
